import React, { useRef, useState } from "react";
import {
  IonModal,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
} from "@ionic/react";
import { useSelector } from "react-redux";
import { actions } from "../../Redux/store";
import { Capacitor } from "@capacitor/core";
import Sleeper from "../../assets/imgs/Platform_small_icon_2.svg";
import YAHOO from "../../assets/imgs/Platform_small_icon_3.svg";
import ESPN from "../../assets/imgs/Platform_new_small_icon_2.svg";
import arrowRight from "../../assets/imgs/select_platform_right.svg";
import { hapticsImpactLight } from "../../lib/utils";
import { useMixpanel } from "../../Context/MixpanelContext/MixpanelProvider";

interface LeagueModal {
  isLeagueModal: boolean;
  toggleLeagueModal: () => void;
}

const PLATFORMCARDSNEW = [
  {
    id: 1,
    title: "Sleeper",
    icon: Sleeper,
    disable: false,
    fantasy_type: "SLEEPER",
  },
  {
    id: 2,
    title: "ESPN Fantasy",
    icon: ESPN,
    disable: true,
    fantasy_type: "ESPN",
  },
  {
    id: 3,
    title: "Yahoo Fantasy",
    icon: YAHOO,
    disable: true,
    fantasy_type: "YAHOO",
  },
];

export default function LeagueModal() {
  const [featurePlatformCards] = useState(PLATFORMCARDSNEW);
  const [selectedPlatform, setSelectedPlatform] = useState<string | null>(null);
  console.log(selectedPlatform, "selectedPlatformselectedPlatform");
  const isLeagueModal = useSelector(
    (sate: any) => sate.modal.leagueModal?.open,
  );
  const platform = Capacitor.getPlatform();
  const modal = useRef<HTMLIonModalElement>(null);
  const toggleLeagueModal = () => {
    actions.modal.closeLeagueModal(null);
  };
  const Mixpanel = useMixpanel();
  const handleCardClick = (platformTitle: string, disabled: boolean) => {
    if (disabled) return;

    hapticsImpactLight();
    setSelectedPlatform(platformTitle); // Update the selected platform when the card is clicked

    if (platformTitle === "SLEEPER") {
      Mixpanel.trackEvent("league_sync_sleeper_selected", {
        name: "User selected sleeper platform",
      });
      toggleSleepModals();
    }
  };

  const closeLeagueModal = () => {
    toggleLeagueModal();
  };
  function dismiss() {
    modal.current?.dismiss();
    closeLeagueModal();
  }

  const toggleSleepModals = () => {
    actions.modal.openSleeperModal(null);
  };

  return (
    <IonModal
      onDidDismiss={dismiss}
      className={`${platform === "web" ? "dark-custom-modal" : "dark-custom-modal"}`}
      isOpen={isLeagueModal}
      backdropDismiss={true}
      initialBreakpoint={0.45}
      breakpoints={[0, 0.45]}
      ref={modal}
    >
      <IonHeader className="ion-no-border modal-ion-header">
        <IonToolbar className="custom-toolbar">
          <div className="flex items-center justify-center w-full px-2  pt-8 ">
            <span className="text-white text-[20px] font-medium leading-[100%] text-center">
              Select Platform to Sync
            </span>
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="px-[30px]">
          <div className="flex-col justify-center pt-6  space-y-[12px] cursor-pointer">
            {featurePlatformCards.map((PlatformData: any, index: any) => {
              return (
                <div
                  className={`${PlatformData.disable ? "opacity-70" : ""} bg-white/5 rounded-[13px] h-[63.75px] w-full f px-[10px]`}
                  key={index}
                  onClick={() =>
                    handleCardClick(
                      PlatformData?.fantasy_type,
                      PlatformData.disable,
                    )
                  }
                  style={{
                    cursor: PlatformData.disable ? "default" : "pointer",
                  }}
                >
                  <div className="flex items-center justify-between w-full h-full">
                    <div className="flex gap-[15px] items-center">
                      <div className="rounded-[8px] w-[42.6px]  h-[42.6px]  flex items-end overflow-hidden">
                        <img
                          src={PlatformData?.icon}
                          alt={PlatformData?.title}
                          className={PlatformData.disable ? "opacity-70" : ""}
                        />
                      </div>
                      <div>
                        <span className="text-white text-[13.5px] font-medium">
                          {PlatformData?.title}
                        </span>
                        {PlatformData.disable && (
                          <span className="text-white/50 text-[11px] ml-1">
                            (Coming Soon)
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="pr-[12px]">
                      <img
                        src={arrowRight}
                        alt=""
                        className={PlatformData.disable ? "opacity-50" : ""}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
}
